import React, { useEffect, useState } from 'react';
import { InvoiceWithLineItems } from '@atlassian/cssxp-types-billing';
import { fetchInvoice } from '@atlassian/temp-proxies';
import { ErrorComponents } from '@css-xp/base';
import { LoadingIndicator } from '@atlassian/temp-loading-indicator';
import ServiceCreditForm from './service-credit-form';

export interface Props {
  invoiceId: string;
}

const ServiceCreditPane = ({ invoiceId }: Props) => {
  const [invoice, setInvoice] = useState<InvoiceWithLineItems>();
  const [error, setError] = useState<Error | null>(null);
  const [isFetching, setIsFetching] = useState<boolean>(true);

  const fetchInvioceData = async () => {
    try {
      const invoiceResponse = await fetchInvoice(invoiceId);
      setInvoice(invoiceResponse);
    } catch (error: any) {
      setError(error.toString());
    }
    setIsFetching(false);
  };

  useEffect(() => {
    setIsFetching(true);
    fetchInvioceData();
  }, [invoiceId]);

  if (error) {
    return <ErrorComponents.GenericErrorPage error={error} />;
  }

  if (isFetching) {
    return <LoadingIndicator />;
  }

  // @ts-ignore
  return <ServiceCreditForm invoice={invoice} />;
};

export default ServiceCreditPane;
